import { mk_widget, Action, IOWidget } from 'widgets-for-react'
import * as React from 'react'

export interface LifecycleProps<s> {
  componentDidMount?: (update: (_: Action<s>) => void) => void
  componentWillUnmount?: (update: (_: Action<s>) => void) => void
  input: s
  widget_s: IOWidget<s, Action<s>>
  on_done_s: (output_s: Action<s>) => void
}
export interface LifecycleState<s> {}
export class Lifecycle<s> extends React.Component<
  LifecycleProps<s>,
  LifecycleState<s>
> {
  constructor(props: LifecycleProps<s>, context: any) {
    super(props, context)
    this.state = {}
  }

  componentDidMount() {
    this.props.componentDidMount && 
      this.props.componentDidMount(this.props.on_done_s)
  }

  componentWillUnmount() {
    this.props.componentWillUnmount && 
      this.props.componentWillUnmount(this.props.on_done_s)
  }

  render() {
    return this.props
      .widget_s(this.props.input)
      .run(new_s => this.props.on_done_s(new_s))
  }
}
export let lifecycle = function<s>(
  componentDidMount?: (update: (_: Action<s>) => void) => void,
  componentWillUnmount?: (update: (_: Action<s>) => void) => void
): (widget_s: IOWidget<s, Action<s>>) => IOWidget<s, Action<s>> {
  return widget_s => (input: s) =>
    mk_widget({
      run: (on_done_s: (output: Action<s>) => void) =>
        React.createElement<LifecycleProps<s>>(Lifecycle, {
          on_done_s,
          widget_s,
          input,
          componentDidMount,
          componentWillUnmount
        })
      })
  }


// WEBPACK FOOTER //
// ./Client/components/public_site/templates/lifecycle.mod.tsx